export default {
    upgradeLine: 'Update Line',
    lineServiceIsUpdated: 'Line Serive is updated',
    congratulation: 'Congratulation',
    description: 'Update for minor bug fixes and improved features</br>Such as refresh menu in LINE application',
    messageSent: 'Message Sent'
}
